import { Reveal, Chapter } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    name: "Say hello",
    desc: "A low-pressure chat about what you do, who you want to reach and what “good” looks like.",
  },
  {
    num: "02",
    name: "Shape the idea",
    desc: "We turn the loose bits into a clear plan, visual direction and quote you can actually read.",
  },
  {
    num: "03",
    name: "Make it real",
    desc: "You get thoughtful design, regular check-ins and a site that works on the phone in your hand.",
  },
  {
    num: "04",
    name: "Put it to work",
    desc: "We launch together, sort the practical details and show you what to do next.",
  },
];

export const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="bg-[#201e32] px-5 py-24 text-[#f3f0e8] sm:px-8 sm:py-32 lg:px-10"
  >
    <div className="mx-auto max-w-7xl">
      <Chapter n="03" label="From first thought to live site" dark />

      <div className="mt-10 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <Reveal>
          <h2 className="font-display text-4xl font-bold leading-[0.98] tracking-[-0.04em] sm:text-6xl">
            No mystery steps.
            <br />
            <span className="text-[#a277fa]">Just momentum.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-[380px] text-base leading-relaxed text-white/60">
            Most websites are completed within 7 days, with clear check-ins along the way.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.1 + i * 0.12}>
            <div
              data-testid={`process-step-${s.num}`}
              className="group relative flex h-full min-h-[260px] flex-col justify-between overflow-hidden rounded-[1.5rem] border border-white/10 p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-[#a277fa]/50"
            >
              <div
                aria-hidden
                className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#7650c7]/20 blur-2xl transition-opacity duration-500 group-hover:opacity-100"
              />
              <p className="font-mono text-sm font-medium tracking-[0.2em] text-[#a277fa]">{s.num}</p>
              <div>
                <h3 className="font-display text-2xl font-bold tracking-[-0.03em]">{s.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
